package dev.krno

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import dev.krno.components.AppBar
import dev.krno.components.CardTilt
import dev.krno.components.CursorTrail
import dev.krno.components.EditableSnippets
import dev.krno.components.HeroPersona
import dev.krno.components.Partners
import dev.krno.components.Program
import dev.krno.components.RegisterCta
import dev.krno.components.SiteFooter
import dev.krno.components.SpeakerModal
import dev.krno.components.Speakers
import dev.krno.components.Venue
import dev.krno.data.Speaker
import dev.krno.reveal.RevealController
import org.jetbrains.compose.web.dom.Main

@Composable
fun App() {
    // Speaker detail modal is triggered from two places: a speaker card in the
    // Speakers section, and a talk row in the Program section. State is hoisted
    // here so both can drive it.
    var openSpeaker by remember { mutableStateOf<Speaker?>(null) }

    AppBar()
    Main(attrs = { id("top") }) {
        HeroPersona()
        Program(onOpenSpeaker = { openSpeaker = it })
        Speakers(onOpenSpeaker = { openSpeaker = it })
        Venue()
        Partners()
        RegisterCta()
    }
    SiteFooter()

    openSpeaker?.let { s ->
        SpeakerModal(speaker = s, onClose = { openSpeaker = null })
    }

    RevealController()
    CursorTrail()
    CardTilt()
    EditableSnippets()
}
